import { Component } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import { AuthService, LogService, LogZone } from '@core';
import { AppRoute } from '@shared';

@Component({
  selector: 'sc-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../auth.scss', './forgot-password.component.scss'],
  standalone: false,
})
export class ForgotPasswordComponent {
  public AppRoute = AppRoute;
  email = '';
  invalid = false;
  loading = false;
  sent = false;

  // eslint-disable-next-line max-len
  emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(
    private authService: AuthService,
    private logService: LogService,
    private toastrService: ToastrService,
  ) {
    this.logService = this.logService.for(LogZone.AUTHENTICATION);
  }

  async sendEmail() {
    if (!this.email.match(this.emailRegex)) {
      this.invalid = true;
      return;
    }

    this.loading = true;
    this.logService.debug('Sending password reset info...', { email: this.email });
    try {
      const sent = await this.authService.sendPasswordResetEmail(this.email);
      this.logService.debug('Password Reset info ', sent);
      this.logService.info('Password reset email sent.', { email: this.email });
      this.sent = true;
    } catch (error) {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/invalid-email') {
        this.logService.warn('Unable to send password reset email. ', { email: this.email }, error);
      } else {
        this.logService.error('Unable to send password reset email. ', { email: this.email }, error);
      }
      this.toastrService.error('Unable to send the password reset email.');
    }
    this.loading = false;
  }
}
